// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perfilContent {
  background-color: #2e3033;
  position: relative;
  height: calc(100vh - 80px);
  width: 55px;
  min-width: 55px;
  display: flex;
  flex-direction: column;
  transition: 0.2s ease-in-out;
  align-items: center;
  overflow: hidden;
}

.modalLogout {
  margin-left: 0px !important;
}

.perfilContent.expanded {
  width: 300px;
  min-width: 300px;
}
.perfilContent .h2Title {
  color: #ffffff;
  font-weight: 700;
  font-size: 20px;
  word-wrap: inherit;
  opacity: 0;
  width: 130px;
  overflow: hidden;
  transition: opacity 0.8s ease-in-out;
}

.perfilContent.expanded .h2Title {
  opacity: 1;
}

.headerSideBar {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 30px 0px 0px 30px;
  position: relative;
  margin-bottom: 30px;
  margin-top: -20px;
  overflow: hidden;
  height: 60px;
}

.h2Title {
  color: #ffffff;
  font-weight: 700;
  font-size: 20px;
  word-wrap: inherit;
  opacity: 0;
  width: 130px;
  overflow: hidden;
}

.perfilContent:hover .h2Title {
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
}

.headerSideBar img {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 22px;
  top: 20px;
  cursor: pointer;
}

.headerSideBar .menuIconH {
  position: relative;
  right: -2px;
  top: 32px;
  margin-bottom: 30px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

img.menuIconH {
  margin-top: -13px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9997;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.8s ease;
}

.overlay.visible {
  opacity: 1;
  visibility: visible;
}

.arrow {
  position: absolute;
  right: 34px;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.perfilContent.expanded .arrow {
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
}

.arrow.open {
  transform: rotate(180deg);
}

.arrow::after {
  transition: transform 0.3s ease;
}

.arrow.open::after {
  transform: rotate(180deg);
}

.menuItemButton {
  padding: 20px 0 20px 16px !important;
  font: inherit;
  color: inherit;
}

.menuItemButtonGrupoResponsabilidade {
  border: none;
  background: none;
  text-align: left;
  font: inherit;
  color: inherit;
  appearance: none;
  display: flex;
  align-items: center;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
}

.menuItem {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 20px 0 20px 30px;
  width: 100%;
  color: #ffffff;
  transition: background-color 0.3s ease, padding 0.3s ease;
  position: relative;
  margin-top: -11px;
}

.menuItem:hover {
  background-color: #ffffff;
  color: black;
  text-align: center;
}

.menuItem img {
  transition: filter 0.3s ease;
}

.menuItem:hover img {
  filter: brightness(0);
}

.menuIcon {
  width: 24px;
  height: 24px;
  margin-right: -20px;
}

.menuIcon.aprovador {
  width: 23px;
  height: 18px;
  margin-right: -20px;
}

.menuIcon.grupoResponsabilidade {
  width: 26px;
  height: 26px;
}

.menuTitle {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
  font-size: 16px;
  font-family: 'Bosch Sans', sans-serif;
}

.menuTitle.grupoResponsabilidade {
  margin-left: 30px !important;
}

.perfilContent.expanded .menuTitle {
  opacity: 1;
  margin-left: 35px;
  transition: opacity 0.5s ease-in-out;
}

.screenLine {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-height: 49px;
  max-height: 49px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 5px;
  margin: 2px 0px;
  transition: background-color 200ms ease, width 200ms ease;
  overflow: hidden;
}

.submenu {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: #ffffff;
}

.perfilContent.epanded .submenu {
  opacity: 1;
}

.submenu div {
  padding: 10px 0 10px 40px;
  cursor: pointer;
  width: 100%;
}

.submenu div:hover {
  background-color: #ffffff;
  color: rgba(0, 0, 0, 1);
  transition: background-color 0.3s ease;
}

.tooltip {
  position: fixed;
  background-color: #b5b5b5;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  visibility: hidden;
  white-space: nowrap;
  z-index: 20;
}

.tooltip.visible {
  visibility: visible;
}

.logoutItem {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}


.iconButton {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/sideBar/sidebar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,yDAAyD;EACzD,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,eAAe;AACjB","sourcesContent":[".perfilContent {\n  background-color: #2e3033;\n  position: relative;\n  height: calc(100vh - 80px);\n  width: 55px;\n  min-width: 55px;\n  display: flex;\n  flex-direction: column;\n  transition: 0.2s ease-in-out;\n  align-items: center;\n  overflow: hidden;\n}\n\n.modalLogout {\n  margin-left: 0px !important;\n}\n\n.perfilContent.expanded {\n  width: 300px;\n  min-width: 300px;\n}\n.perfilContent .h2Title {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 20px;\n  word-wrap: inherit;\n  opacity: 0;\n  width: 130px;\n  overflow: hidden;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.perfilContent.expanded .h2Title {\n  opacity: 1;\n}\n\n.headerSideBar {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  padding: 30px 0px 0px 30px;\n  position: relative;\n  margin-bottom: 30px;\n  margin-top: -20px;\n  overflow: hidden;\n  height: 60px;\n}\n\n.h2Title {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 20px;\n  word-wrap: inherit;\n  opacity: 0;\n  width: 130px;\n  overflow: hidden;\n}\n\n.perfilContent:hover .h2Title {\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.headerSideBar img {\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  right: 22px;\n  top: 20px;\n  cursor: pointer;\n}\n\n.headerSideBar .menuIconH {\n  position: relative;\n  right: -2px;\n  top: 32px;\n  margin-bottom: 30px;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\nimg.menuIconH {\n  margin-top: -13px;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9997;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.8s ease;\n}\n\n.overlay.visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n.arrow {\n  position: absolute;\n  right: 34px;\n  opacity: 0;\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.perfilContent.expanded .arrow {\n  opacity: 1;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.arrow.open {\n  transform: rotate(180deg);\n}\n\n.arrow::after {\n  transition: transform 0.3s ease;\n}\n\n.arrow.open::after {\n  transform: rotate(180deg);\n}\n\n.menuItemButton {\n  padding: 20px 0 20px 16px !important;\n  font: inherit;\n  color: inherit;\n}\n\n.menuItemButtonGrupoResponsabilidade {\n  border: none;\n  background: none;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  appearance: none;\n  display: flex;\n  align-items: center;\n  padding: 0px;\n  margin: 0px;\n  cursor: pointer;\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 20px 0 20px 30px;\n  width: 100%;\n  color: #ffffff;\n  transition: background-color 0.3s ease, padding 0.3s ease;\n  position: relative;\n  margin-top: -11px;\n}\n\n.menuItem:hover {\n  background-color: #ffffff;\n  color: black;\n  text-align: center;\n}\n\n.menuItem img {\n  transition: filter 0.3s ease;\n}\n\n.menuItem:hover img {\n  filter: brightness(0);\n}\n\n.menuIcon {\n  width: 24px;\n  height: 24px;\n  margin-right: -20px;\n}\n\n.menuIcon.aprovador {\n  width: 23px;\n  height: 18px;\n  margin-right: -20px;\n}\n\n.menuIcon.grupoResponsabilidade {\n  width: 26px;\n  height: 26px;\n}\n\n.menuTitle {\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  white-space: nowrap;\n  overflow: hidden;\n  font-size: 16px;\n  font-family: 'Bosch Sans', sans-serif;\n}\n\n.menuTitle.grupoResponsabilidade {\n  margin-left: 30px !important;\n}\n\n.perfilContent.expanded .menuTitle {\n  opacity: 1;\n  margin-left: 35px;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.screenLine {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  min-height: 49px;\n  max-height: 49px;\n  font-size: 15px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 5px;\n  margin: 2px 0px;\n  transition: background-color 200ms ease, width 200ms ease;\n  overflow: hidden;\n}\n\n.submenu {\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  color: #ffffff;\n}\n\n.perfilContent.epanded .submenu {\n  opacity: 1;\n}\n\n.submenu div {\n  padding: 10px 0 10px 40px;\n  cursor: pointer;\n  width: 100%;\n}\n\n.submenu div:hover {\n  background-color: #ffffff;\n  color: rgba(0, 0, 0, 1);\n  transition: background-color 0.3s ease;\n}\n\n.tooltip {\n  position: fixed;\n  background-color: #b5b5b5;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  visibility: hidden;\n  white-space: nowrap;\n  z-index: 20;\n}\n\n.tooltip.visible {\n  visibility: visible;\n}\n\n.logoutItem {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n\n.iconButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
